// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
.form {
  align-items: flex-start;
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
}
@media (max-width: 1023px) {
  .form {
    width: 100%;
  }
}

.form .header {
  align-items: flex-start;
  align-self: stretch;
  background: var(--vrise-application-form-header);
  background-color: transparent;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  border-radius: 20px 20px 0px 0px;
}

.form .info {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  padding: 20px 24px;
  position: relative;
  width: 100%;
}
@media (max-width: 650px) {
  .form .info {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
}

.form .div {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  position: relative;
  color: var(--tertiary-text-color);
}

.form .div-2 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
}

.form .image-div {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 30px;
  justify-content: center;
  position: relative;
  width: 30px;
}

.form .image {
  height: 30px;
  object-fit: cover;
  position: relative;
  width: 30px;
}

.form .text-wrapper {
  color: #f2f4fa;
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 125%; /* 20px */
}

.form .text-wrapper-2 {
  color: #f2f4fa;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 100%; /* 20px */
}

.form .info-2 {
  align-items: flex-end;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  position: relative;
}
@media (max-width: 650px) {
  .form .info-2 {
    align-items: flex-start;
  }
}

.form .text-wrapper-3 {
  color: #f2f4fa;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%; /* 14px */
}

.form .line {
  height: 10px;
  object-fit: cover;
  position: relative;
  width: 1px;
}

.form .info-3 {
  align-items: flex-end;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  position: relative;
}
@media (max-width: 650px) {
  .form .info-3 {
    align-items: flex-start;
  }
}

.form .text-wrapper-4 {
  color: #f2f4fa;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}

.form .section {
  align-items: center;
  align-self: stretch;
  background-color: var(--primary-surface-color);
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 24px;
  padding: 24px 24px 24px;
  position: relative;
  width: 100%;
  border-radius: 0px 0px 24px 24px;
}

.form .user-data {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
}

.form .profile {
  border: 0.72px solid;
  border-color: var(--border-color);
  border-radius: 57.6px;
  height: 72px;
  position: relative;
  width: 72px;
}

.form .name-linkedin {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  justify-content: flex-end;
  position: relative;
}

.form .text-wrapper-6 {
  color: var(--primary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%; /* 16px */
}

.form .div-3 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  opacity: 0.8;
  position: relative;
}

.form .img {
  height: 18px;
  position: relative;
  width: 18px;
}

.form .text-wrapper-7 {
  color: var(--secondary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}

.form .input {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: 100%;
}

.form .div-4 {
  color: var(--primary-text-color);
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
}
@media (max-width: 650px) {
  .form .div-4 {
    white-space: normal;
    margin-top: -6px;
  }
}

.form .files {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
  width: 100%;
}
@media (max-width: 650px) {
  .form .files {
    flex-direction: column;
    align-items: flex-start;
  }
}

.form .file-info {
  align-items: center;
  background-color: var(--secondary-surface-color);
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 12px;
  display: flex;
  flex: 1;
  flex-grow: 1;
  justify-content: space-between;
  padding: 8px 16px;
  position: relative;
}
@media (max-width: 650px) {
  .form .file-info {
    width: 100%;
  }
}

.form .radio-button-instance {
  border-radius: 16px;
  border: 4.8px solid var(--accent-primary-blue-color);
  background: var(--primary-surface-color);
  border-radius: 16px !important;
  height: 16px !important;
  position: relative !important;
  width: 16px !important;
}

.form .pdf {
  border: 1px solid;
  border-color: #73abff;
  border-radius: 6px;
  height: 42px;
  margin-bottom: -1px;
  margin-top: -1px;
  position: relative;
  width: 42px;
}

.form .group {
  height: 40px;
  left: 0;
  position: absolute;
  top: 0;
  width: 40px;
}

.form .text-wrapper-8 {
  color: var(--primary-text-color);
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.form .text {
  color: var(--primary-text-color);
  font-family: "General Sans-Semibold", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 17.5px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}

.form .text-wrapper-9 {
  color: var(--quartinary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.form .file-info-2 {
  align-items: center;
  background-color: var(--secondary-surface-color);
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 12px;
  display: flex;
  flex: 1;
  flex-grow: 1;
  height: 56px;
  justify-content: space-between;
  padding: 8px 16px;
  position: relative;
}
@media (max-width: 650px) {
  .form .file-info-2 {
    width: 100%;
  }
}

.form .text-wrapper-10 {
  color: var(--primary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 17.5px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}

.form .publish {
  height: 20px;
  position: relative;
  width: 20px;
}

.form .input-fields {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 20px 20px;
  position: relative;
  width: 100%;
}

.form .arrow-drop-down {
  height: 24px;
  margin-bottom: -6px;
  margin-top: -6px;
  position: relative;
  width: 24px;
}

.form .bottom {
  align-items: center;
  background-color: var(--accent-quinary-blue-color);
  border-color: var(--border-color);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  margin-left: -24px;
  margin-right: -24px;
  padding: 24px;
  position: relative;
  width: 105%;
}
@media (max-width: 650px) {
  .form .bottom {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    width: 95vw;
  }
}

.form .t-and-c {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  position: relative;
}
@media (max-width: 650px) {
  .form .t-and-c {
    width: 100%;
  }
}

.form .checkbox {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
}
@media (max-width: 650px) {
  .form .checkbox {
    align-items: flex-start;
  }
}

.form .button {
  all: unset;
  align-items: center;
  background-color: #73abff;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 16px 0px;
  position: relative;
  width: 200px;
}

.form .text-2 {
  color: var(--primary-surface-color);
  text-align: center;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 125%; /* 20px */
}

.submitted-resume-container {
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--secondary-surface-color);
}

.submitted-resume-text {
  color: var(--accent-primary-blue-color);
  text-align: center;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
  text-decoration: none;
}

.profile-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
@media (max-width: 650px) {
  .profile-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
}

.modal-section {
  display: flex;
  padding: 32px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}
.modal-body .policy-link {
  color: var(--accent-primary-blue-color);
  font-family: "Medium Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}
.modal-body .policy-link:hover {
  text-decoration: underline;
}

.policy-checkbox {
  color: var(--primary-text-color);
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 20px */
}

.modal-text {
  color: var(--primary-text-color);
  font-family: "Medium Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.modal-footer .checkbox-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.profile-button-text-save {
  display: flex;
  width: 180px;
  padding: 16px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--accent-primary-blue-color);
  color: var(--primary-surface-color);
  text-align: center;
  font-family: "Semi Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
}

.profile-confirmation-modal {
  display: flex;
  width: 850px;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  background: var(--profile-success-gradient-bg);
}
@media (max-width: 650px) {
  .profile-confirmation-modal {
    height: 100vh;
  }
}

.profile-confirmation-cta {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
}

.profile-confirmation-cta-text {
  color: var(--accent-primary-blue-color);
  text-align: center;
  /* New Typeface/CTA primary */
  font-family: "Semi Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%; /* 20px */
}

.apply-now-container {
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 28px;
  width: 80%;
  position: relative;
  z-index: 10;
}
@media (max-width: 1023px) {
  .apply-now-container {
    width: 100%;
  }
}
@media (max-width: 650px) {
  .apply-now-container {
    padding: 20px 10px 20px 10px;
  }
}

.apply-now-form-back-button {
  color: var(--primary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%; /* 18px */
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.error-background {
  background: var(--vrise-error-container-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 90px);
  overflow: hidden;
}

.error-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.error-heading {
  color: var(--secondary-text-color);
  text-align: center;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 100%; /* 40px */
}

.error-description {
  color: var(--tertiary-text-color);
  text-align: center;
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 150%; /* 42px */
}

@media (max-width: 650px) {
  .vrise-mobile-view-form {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/pages/VRise/applyForm.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACAF;ADGA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACFF;ADIA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACHF;ADKA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACJF;AArBA;EACI,uBAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAuBJ;ACsEE;EDpGF;IASQ,WAAA;EAyBN;AACF;;AAtBA;EACI,uBAAA;EACA,mBAAA;EACA,gDAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AAyBJ;;AAtBA;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAyBJ;ACwCE;EDzEF;IAUQ,sBAAA;IACA,uBAAA;IACA,SAAA;EA2BN;AACF;;AAxBA;EACI,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,iCAAA;AA2BJ;;AAxBA;EACI,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AA2BJ;;AAxBA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AA2BJ;;AAxBA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AA2BJ;;AAxBA;EACI,cAAA;EC5CF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED4CE,eAAA;EACA,iBAAA,EAAA,SAAA;AA6BJ;;AA1BA;EACI,cAAA;EC9CF,oCAAA;EACA,kBAAA;EACA,gBAAA;ED8CE,eAAA;EACA,iBAAA,EAAA,SAAA;AA+BJ;;AA5BA;EACI,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AA+BJ;AC9BE;EDRF;IASQ,uBAAA;EAiCN;AACF;;AA9BA;EACI,cAAA;EClEF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDkEE,eAAA;EACA,iBAAA,EAAA,SAAA;AAmCJ;;AAhCA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAmCJ;;AAhCA;EACI,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAmCJ;AC5DE;EDmBF;IAQQ,uBAAA;EAqCN;AACF;;AAlCA;EACI,cAAA;EC5FF,oCAAA;EACA,kBAAA;EACA,gBAAA;ED4FE,eAAA;EACA,iBAAA,EAAA,WAAA;AAuCJ;;AApCA;EACI,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AAuCJ;;AAjCA;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAoCJ;;AAjCA;EACI,oBAAA;EACA,iCAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAoCJ;;AAjCA;EACI,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAoCJ;;AAjCA;EACI,gCAAA;EChJF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDgJE,eAAA;EACA,iBAAA,EAAA,SAAA;AAsCJ;;AAnCA;EACI,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAsCJ;;AAnCA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAsCJ;;AAnCA;EACI,kCAAA;EC5KF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED4KE,eAAA;EACA,iBAAA,EAAA,WAAA;AAwCJ;;AArCA;EACI,uBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AAwCJ;;AArCA;EACI,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ECjMF,sCAAA;EACA,kBAAA;EACA,gBAAA;AD0OF;AC3KE;ED2HF;IAQQ,mBAAA;IACA,gBAAA;EA4CN;AACF;;AAzCA;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AA4CJ;AC3LE;EDwIF;IASQ,sBAAA;IACA,uBAAA;EA8CN;AACF;;AA3CA;EACI,mBAAA;EACA,gDAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AA8CJ;AC/ME;EDsJF;IAaQ,WAAA;EAgDN;AACF;;AA7CA;EACI,mBAAA;EACA,oDAAA;EACA,wCAAA;EACA,8BAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;AAgDJ;;AA7CA;EACI,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAgDJ;;AA7CA;EACI,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAgDJ;;AA7CA;EACI,gCAAA;EAEA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA+CJ;;AA5CA;EACI,gCAAA;EACA,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA+CJ;;AA5CA;EACI,mCAAA;EC3RF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED2RE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAiDJ;;AA9CA;EACI,mBAAA;EACA,gDAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAiDJ;ACjSE;EDoOF;IAcQ,WAAA;EAmDN;AACF;;AAhDA;EACI,gCAAA;ECxTF,sCAAA;EACA,kBAAA;EACA,gBAAA;EDwTE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAqDJ;;AAlDA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAqDJ;;AAlDA;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAqDJ;;AAlDA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAqDJ;;AAlDA;EACI,mBAAA;EACA,kDAAA;EACA,iCAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAqDJ;AC7VE;ED2RF;IAeQ,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;EAuDN;AACF;;AApDA;EACI,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AAuDJ;AChXE;EDkTF;IASQ,WAAA;EAyDN;AACF;;AAtDA;EACI,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAyDJ;AC7XE;ED+TF;IAOQ,uBAAA;EA2DN;AACF;;AAxDA;EACI,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AA2DJ;;AAxDA;EACI,mCAAA;EACA,kBAAA;ECtZF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDsZE,eAAA;EACA,iBAAA,EAAA,SAAA;AA6DJ;;AA1DA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;AA6DJ;;AA1DA;EACI,uCAAA;EACA,kBAAA;ECxaF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDwaE,eAAA;EACA,iBAAA,EAAA,WAAA;EACA,qBAAA;AA+DJ;;AA5DA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AA+DJ;ACtbE;EDmXF;IAMQ,sBAAA;IACA,uBAAA;IACA,SAAA;EAiEN;AACF;;AA9DA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAiEJ;;AA9DA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAiEJ;AA/DI;EACI,uCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAiER;AA/DQ;EACI,0BAAA;AAiEZ;;AA5DA;EACI,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA+DJ;;AA5DA;EACI,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA+DJ;;AA3DI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AA8DR;;AA1DA;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,4CAAA;EACA,mCAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA6DJ;;AA1DA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;EACA,8CAAA;AA6DJ;AChhBE;EDycF;IAYQ,aAAA;EA+DN;AACF;;AA5DA;EACI,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AA+DJ;;AA5DA;EACI,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA+DJ;;AA5DA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AA+DJ;ACljBE;ED2eF;IAUQ,WAAA;EAiEN;AACF;ACvjBE;ED2eF;IAaQ,4BAAA;EAmEN;AACF;;AAhEA;EACI,gCAAA;ECzjBF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDyjBE,eAAA;EACA,iBAAA,EAAA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAqEJ;;AAlEA;EACI,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAqEJ;;AAlEA;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAqEJ;;AAlEA;EACI,kCAAA;EACA,kBAAA;ECrlBF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDqlBE,eAAA;EACA,iBAAA,EAAA,SAAA;AAuEJ;;AApEA;EACI,iCAAA;EACA,kBAAA;EClmBF,sCAAA;EACA,kBAAA;EACA,gBAAA;EDkmBE,eAAA;EACA,iBAAA,EAAA,SAAA;AAyEJ;;AC7mBE;EDuiBF;IAEQ,sBAAA;EAyEN;AACF","sourcesContent":["@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@import \"../../styles/styles.scss\";\n\n.form {\n    align-items: flex-start;\n    border: 1px solid;\n    border-color: var(--border-color);\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    @include respond-to(1023px) {\n        width: 100%;\n    }\n}\n\n.form .header {\n    align-items: flex-start;\n    align-self: stretch;\n    background: var(--vrise-application-form-header);\n    background-color: transparent;\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    border-radius: 20px 20px 0px 0px;\n}\n\n.form .info {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: space-between;\n    padding: 20px 24px;\n    position: relative;\n    width: 100%;\n    @include respond-to(650px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n    }\n}\n\n.form .div {\n    align-items: flex-start;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 8px;\n    position: relative;\n    color: var(--tertiary-text-color);\n}\n\n.form .div-2 {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 12px;\n    position: relative;\n}\n\n.form .image-div {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    height: 30px;\n    justify-content: center;\n    position: relative;\n    width: 30px;\n}\n\n.form .image {\n    height: 30px;\n    object-fit: cover;\n    position: relative;\n    width: 30px;\n}\n\n.form .text-wrapper {\n    color: #f2f4fa;\n    @include MediumSans;\n    font-size: 16px;\n    line-height: 125%; /* 20px */\n}\n\n.form .text-wrapper-2 {\n    color: #f2f4fa;\n    @include SemiSans;\n    font-size: 20px;\n    line-height: 100%; /* 20px */\n}\n\n.form .info-2 {\n    align-items: flex-end;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 12px;\n    justify-content: center;\n    position: relative;\n    @include respond-to(650px) {\n        align-items: flex-start;\n    }\n}\n\n.form .text-wrapper-3 {\n    color: #f2f4fa;\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 100%; /* 14px */\n}\n\n.form .line {\n    height: 10px;\n    object-fit: cover;\n    position: relative;\n    width: 1px;\n}\n\n.form .info-3 {\n    align-items: flex-end;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 8px;\n    position: relative;\n    @include respond-to(650px) {\n        align-items: flex-start;\n    }\n}\n\n.form .text-wrapper-4 {\n    color: #f2f4fa;\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n}\n\n.form .section {\n    align-items: center;\n    align-self: stretch;\n    background-color: var(--primary-surface-color);\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 24px;\n    padding: 24px 24px 24px;\n    position: relative;\n    width: 100%;\n    border-radius: 0px 0px 24px 24px;\n    // @include respond-to(650px) {\n    //     padding: 20px 20px 0px !important;\n    // }\n}\n\n.form .user-data {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    gap: 12px;\n    position: relative;\n}\n\n.form .profile {\n    border: 0.72px solid;\n    border-color: var(--border-color);\n    border-radius: 57.6px;\n    height: 72px;\n    position: relative;\n    width: 72px;\n}\n\n.form .name-linkedin {\n    align-items: flex-start;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 12px;\n    justify-content: flex-end;\n    position: relative;\n}\n\n.form .text-wrapper-6 {\n    color: var(--primary-text-color);\n    @include SemiSans;\n    font-size: 16px;\n    line-height: 100%; /* 16px */\n}\n\n.form .div-3 {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 8px;\n    justify-content: center;\n    opacity: 0.8;\n    position: relative;\n}\n\n.form .img {\n    height: 18px;\n    position: relative;\n    width: 18px;\n}\n\n.form .text-wrapper-7 {\n    color: var(--secondary-text-color);\n    @include MediumSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n}\n\n.form .input {\n    align-items: flex-start;\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 8px;\n    position: relative;\n    width: 100%;\n}\n\n.form .div-4 {\n    color: var(--primary-text-color);\n    margin-top: -1px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n    @include MediumSans;\n    @include respond-to(650px) {\n        white-space: normal;\n        margin-top: -6px;\n    }\n}\n\n.form .files {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    gap: 16px;\n    position: relative;\n    width: 100%;\n    @include respond-to(650px) {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.form .file-info {\n    align-items: center;\n    background-color: var(--secondary-surface-color);\n    border: 1px solid;\n    border-color: var(--border-color);\n    border-radius: 12px;\n    display: flex;\n    flex: 1;\n    flex-grow: 1;\n    justify-content: space-between;\n    padding: 8px 16px;\n    position: relative;\n    @include respond-to(650px) {\n        width: 100%;\n    }\n}\n\n.form .radio-button-instance {\n    border-radius: 16px;\n    border: 4.8px solid var(--accent-primary-blue-color);\n    background: var(--primary-surface-color);\n    border-radius: 16px !important;\n    height: 16px !important;\n    position: relative !important;\n    width: 16px !important;\n}\n\n.form .pdf {\n    border: 1px solid;\n    border-color: #73abff;\n    border-radius: 6px;\n    height: 42px;\n    margin-bottom: -1px;\n    margin-top: -1px;\n    position: relative;\n    width: 42px;\n}\n\n.form .group {\n    height: 40px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 40px;\n}\n\n.form .text-wrapper-8 {\n    color: var(--primary-text-color);\n\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.form .text {\n    color: var(--primary-text-color);\n    font-family: \"General Sans-Semibold\", Helvetica;\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 17.5px;\n    position: relative;\n    text-align: center;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.form .text-wrapper-9 {\n    color: var(--quartinary-text-color);\n    @include MediumSans;\n    font-size: 14px;\n    letter-spacing: 0;\n    line-height: 14px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.form .file-info-2 {\n    align-items: center;\n    background-color: var(--secondary-surface-color);\n    border: 1px solid;\n    border-color: var(--border-color);\n    border-radius: 12px;\n    display: flex;\n    flex: 1;\n    flex-grow: 1;\n    height: 56px;\n    justify-content: space-between;\n    padding: 8px 16px;\n    position: relative;\n    @include respond-to(650px) {\n        width: 100%;\n    }\n}\n\n.form .text-wrapper-10 {\n    color: var(--primary-text-color);\n    @include MediumSans;\n    font-size: 14px;\n    letter-spacing: 0;\n    line-height: 17.5px;\n    position: relative;\n    text-align: center;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.form .publish {\n    height: 20px;\n    position: relative;\n    width: 20px;\n}\n\n.form .input-fields {\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    flex-wrap: wrap;\n    gap: 20px 20px;\n    position: relative;\n    width: 100%;\n}\n\n.form .arrow-drop-down {\n    height: 24px;\n    margin-bottom: -6px;\n    margin-top: -6px;\n    position: relative;\n    width: 24px;\n}\n\n.form .bottom {\n    align-items: center;\n    background-color: var(--accent-quinary-blue-color);\n    border-color: var(--border-color);\n    border-top-style: solid;\n    border-top-width: 1px;\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: space-between;\n    margin-left: -24px;\n    margin-right: -24px;\n    padding: 24px;\n    position: relative;\n    width: 105%;\n    @include respond-to(650px) {\n        padding: 20px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n        width: 95vw;\n    }\n}\n\n.form .t-and-c {\n    align-items: flex-start;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 12px;\n    justify-content: center;\n    position: relative;\n    @include respond-to(650px) {\n        width: 100%;\n    }\n}\n\n.form .checkbox {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 12px;\n    position: relative;\n    @include respond-to(650px) {\n        align-items: flex-start;\n    }\n}\n\n.form .button {\n    all: unset;\n    align-items: center;\n    background-color: #73abff;\n    border-radius: 8px;\n    box-sizing: border-box;\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    padding: 16px 0px;\n    position: relative;\n    width: 200px;\n}\n\n.form .text-2 {\n    color: var(--primary-surface-color);\n    text-align: center;\n    @include SemiSans;\n    font-size: 16px;\n    line-height: 125%; /* 20px */\n}\n\n.submitted-resume-container {\n    display: flex;\n    padding: 12px 16px;\n    align-items: center;\n    gap: 20px;\n    border-radius: 12px;\n    border: 1px solid var(--border-color);\n    background: var(--secondary-surface-color);\n}\n\n.submitted-resume-text {\n    color: var(--accent-primary-blue-color);\n    text-align: center;\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n    text-decoration: none;\n}\n\n.profile-section {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    @include respond-to(650px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n    }\n}\n\n.modal-section {\n    display: flex;\n    padding: 32px 40px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 24px;\n    align-self: stretch;\n}\n\n.modal-body {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    align-self: stretch;\n\n    .policy-link {\n        color: var(--accent-primary-blue-color);\n        font-family: \"Medium Sans\";\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 150%; /* 24px */\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n}\n\n.policy-checkbox {\n    color: var(--primary-text-color);\n    font-family: \"Medium Sans\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%; /* 20px */\n}\n\n.modal-text {\n    color: var(--primary-text-color);\n    font-family: \"Medium Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%; /* 24px */\n}\n\n.modal-footer {\n    .checkbox-container {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n    }\n}\n\n.profile-button-text-save {\n    display: flex;\n    width: 180px;\n    padding: 16px 0px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 8px;\n    background: var(--accent-primary-blue-color);\n    color: var(--primary-surface-color);\n    text-align: center;\n    font-family: \"Semi Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 125%;\n}\n\n.profile-confirmation-modal {\n    display: flex;\n    width: 850px;\n    padding: 48px 24px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 28px;\n    border-radius: 20px;\n    border: 1px solid var(--border-color);\n    background: var(--profile-success-gradient-bg);\n    @include respond-to(650px) {\n        height: 100vh;\n    }\n}\n\n.profile-confirmation-cta {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 24px;\n}\n\n.profile-confirmation-cta-text {\n    color: var(--accent-primary-blue-color);\n    text-align: center;\n    /* New Typeface/CTA primary */\n    font-family: \"Semi Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 125%; /* 20px */\n}\n\n.apply-now-container {\n    display: flex;\n    padding: 32px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 28px;\n    width: 80%;\n    position: relative;\n    z-index: 10;\n    @include respond-to(1023px) {\n        width: 100%;\n    }\n    @include respond-to(650px) {\n        padding: 20px 10px 20px 10px;\n    }\n}\n\n.apply-now-form-back-button {\n    color: var(--primary-text-color);\n    @include SemiSans;\n    font-size: 18px;\n    line-height: 100%; /* 18px */\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n}\n\n.error-background {\n    background: var(--vrise-error-container-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: calc(100vh - 90px);\n    overflow: hidden;\n}\n\n.error-container {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n}\n\n.error-heading {\n    color: var(--secondary-text-color);\n    text-align: center;\n    @include SemiSans;\n    font-size: 40px;\n    line-height: 100%; /* 40px */\n}\n\n.error-description {\n    color: var(--tertiary-text-color);\n    text-align: center;\n    @include MediumSans;\n    font-size: 28px;\n    line-height: 150%; /* 42px */\n}\n\n.vrise-mobile-view-form {\n    @include respond-to(650px) {\n        width: 100% !important;\n    }\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
